import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import useGetVsic from '../../../../../common/category/useGetVsic'
import { Element } from '../../../../../common/html/element'
import { Icon } from '../../../../../common/html/icon'
import { Loading } from '../../../../../common/loading'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import { selectCompanyInfo } from '../../../../../companyAnalysis/common/header/companyInfo/store/slice'
import { getDefaultVsic } from '../../../../../companyAnalysis/industry/helper'
import { MAIN_SCREEN, SCREEN } from '../../../constant'
import { getPanelDetail } from '../../../helper'
import { DEFAULT_INDUSTRY } from '../../../helper/companyAnalysis/industryAnalysis'
import { TitlePanelSetting } from '../TitlePanelSetting'
import { COVER_PAGE_ID } from '../constant'
import classes from '../index.module.scss'
import {
  KEY_LOADING,
  changeValue,
  resetSettingPanel,
  selectActivePanel,
  selectCompanyType,
  selectDetailPanel,
  selectLoading,
} from '../store/slice'
import { getIndicators } from '../store/thunk'
import CoverPage from './CoverPage'
import NamePanel from './NamePanel'
import NotePanel from './NotePanel'
import ViewBy from './ViewBy'
import Information from './information'

const SettingPanel = () => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const activePanel = useSelector(selectActivePanel)
  const panel = useSelector(selectDetailPanel(activePanel))
  const loading = useSelector(selectLoading(KEY_LOADING.INDICATOR))
  const companyType = useSelector(selectCompanyType)
  const companyInfo = useSelector(selectCompanyInfo)
  const { vsics } = useGetVsic()

  const [isShowPopupReset, setIsShowPopupReset] = useState(false)

  // layout setting
  const settingPanel = getPanelDetail({
    mainScreen: panel?.mainScreen,
    screen: panel?.screen,
    panel: panel?.panel,
    companyType,
  }).settingPanel

  const isMapTitleApi =
    panel?.screen === SCREEN[MAIN_SCREEN.COMPANY_ANALYSIS].FINANCIAL_ANALYSIS &&
    !!settingPanel?.ratioGroupCode

  useEffect(() => {
    if (isMapTitleApi) {
      dispatch(
        getIndicators({
          GroupCode: settingPanel?.ratioGroupCode,
          CompanyType: companyType,
        }),
      )
    }
  }, [settingPanel?.ratioGroupCode, locale])

  const setValue = (key, value) => {
    dispatch(
      changeValue({
        id: panel?.id,
        key,
        value,
      }),
    )
  }

  const setDefault = () => {
    dispatch(resetSettingPanel(panel?.id))
    if (panel?.screen === 'industryAnalysis') {
      dispatch(
        changeValue({
          id: panel?.id,
          key: `setting.${DEFAULT_INDUSTRY}`,
          value: getDefaultVsic(vsics, companyInfo.mainVsicId).id,
        }),
      )
    }
    setIsShowPopupReset(false)
  }

  const isCoverPage = activePanel === COVER_PAGE_ID

  if (!activePanel || (!isCoverPage && !panel)) {
    return
  }

  if (isCoverPage) {
    return <CoverPage />
  }

  if (loading) {
    return <Loading />
  }

  // value setting
  const setting = panel.setting || {}

  const viewBy = setting.viewBy

  // layout setting
  const viewByList = settingPanel?.viewByList

  const informationSetting = !viewBy
    ? settingPanel?.items
    : settingPanel?.[viewBy]

  const isFirstLevelInline = settingPanel?.isInline

  return (
    <div className={classes.panelList}>
      <div className="dFlex alignItemsCenter">
        <Element
          style={{ fontSize: 14, color: '#191D25' }}
          className={`${classes.title} w100`}
        >
          <TitlePanelSetting label={panel.label} />
          {panel.mainScreen && (
            <span>
              {' '}
              {panel.mainScreen === MAIN_SCREEN.COMPANY_ANALYSIS
                ? '(C)'
                : '(P)'}
            </span>
          )}
        </Element>
        <Element
          style={{ border: '1px solid #6D9DCF', color: '#0553A5' }}
          className={classes.btnReset}
          onClick={() => setIsShowPopupReset(true)}
        >
          <Icon
            style={{ color: '#0553A5', fontSize: 13 }}
            className="icon-reset2"
          />
          <Translate value="preferenceSetting.RESET" />
        </Element>
      </div>
      <div className={`${classes.note} pt1`}>
        <Translate value="financialAnalysis.PANEL_SETTING_NOTE" />
      </div>
      <div className={classes.contentSetting}>
        <ScrollComponent>
          <div className={classes.scrollContainer}>
            <NamePanel panel={panel} setValue={setValue} />
            {viewByList && (
              <ViewBy
                viewByList={viewByList}
                viewBy={viewBy}
                setValue={setValue}
              />
            )}
            {informationSetting && (
              <Information
                setting={setting}
                setValue={setValue}
                informationSetting={informationSetting}
                isFirstLevelInline={isFirstLevelInline}
                isMapTitleApi={isMapTitleApi}
                id={panel.id}
              />
            )}
            <NotePanel setting={setting} setValue={setValue} />
          </div>
        </ScrollComponent>
      </div>
      <PopupAction
        isShow={isShowPopupReset}
        title="preferenceSetting.CONFIRMATION_2"
        handleClose={() => setIsShowPopupReset(false)}
        btnCancel={{
          label: 'common.NO',
          event: () => setIsShowPopupReset(false),
          isI18n: true,
        }}
        btnSubmit={{
          label: 'common.YES',
          event: setDefault,
          isI18n: true,
        }}
      >
        <Translate value="preferenceSetting.RESET_TEMPLATE" />
      </PopupAction>
    </div>
  )
}

export default SettingPanel
